import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'NOTIFICATION_TEMPLATES',
    itemActionName: 'NOTIFICATION_TEMPLATE',
});
